import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from "vuex-module-decorators";
import { Shop, ShopAggregations } from "@/api/types";
import { getShop, getShopAggregations } from "@/api/shops";
import store from "@/store";

export interface ShopsState {
  shop: Shop;
  shopAggregations: ShopAggregations;
}

@Module({ dynamic: true, store, name: "shops" })
class Shops extends VuexModule implements ShopsState {
  public shop: Shop = {
    _id: "",
    name: "",
    description: "",
    resourceAnyMode: "",
    logoDownloadUrl: "",
    address: {
      line1: "",
      line2: "",
      line3: "",
      region: "",
      district: "",
      country: "",
      postcode: ""
    },
    googleMapsUrl: "",
    daysOpen: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false
    },
    openingTimes: {},
    closingTimes: {},
    lunchTimes: {},
    isEnabled: false,
    contactNumber: "",
    contactEmail: "",
    colorTheme: "",
    serviceSelectionTitle: "",
    servicePackageSelectionTitle: "",
    employeeSelectionTitle: "",
    timeSelectionTitle: "",
    hasCustomerAddressField: false
  };

  public shopAggregations: ShopAggregations = {
    services: {},
    resources: {}
  };

  @Mutation
  private SET_SHOP(shop: Shop) {
    this.shop = shop;
  }

  @Mutation
  private SET_SHOP_AGGREGATIONS(shopAggregations: ShopAggregations) {
    this.shopAggregations = shopAggregations;
  }

  @Action({ rawError: true })
  public async getShop(id: string) {
    const { data } = await getShop(id);
    this.SET_SHOP(data);
  }

  @Action({ rawError: true })
  public async getShopAggregations(id: string) {
    const { data } = await getShopAggregations(id);
    this.SET_SHOP_AGGREGATIONS(data);
  }
}

export const ShopsModule = getModule(Shops);
